import { useContext } from "react";
import { useStatuses } from "hooks";
import QueryContext from "state/query";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTag } from "@fortawesome/pro-light-svg-icons";
import { faTag as solidTag } from "@fortawesome/pro-solid-svg-icons";
import DropdownSelect from "./DropdownSelect";
import s from "./filter.module.css";

const SelectStatuses = () => {
  const { statuses } = useStatuses();
  const { statuses: selectedStatuses, setStatus } = useContext(QueryContext);

  return (
    <div className="relative h-full grow text-center group">
      <DropdownSelect
        title="status"
        value={selectedStatuses}
        options={statuses}
        onChange={setStatus}
        icon={<FontAwesomeIcon icon={faTag} className={`${s.icon} group-hover:hidden`} />}
        iconHover={<FontAwesomeIcon icon={solidTag} className={`${s.icon} hidden group-hover:inline-block`} />}
      />
    </div>
  );
};

export default SelectStatuses;
